import React, { type FormEvent } from 'react'
import Icon from '../../icon/Icon'
import _ from 'lodash'
import { store } from '../../../store/store'
import CustomFormLable from '../customModalUtils/CustomFormLable'
import FileInput from '../../../components/shared/UIv2/Input/FileInput'
import Card from '../../../components/shared/UIv2/Card/Card'

export interface CustomFileInputProps {
    row: any
    register: any
    errors: any
    getValues: any
}

export default function CustomSingleFileInput({ row, register, errors, getValues }: CustomFileInputProps): React.ReactElement {
    if (row.ownerIdentity === true) {
        return <div className="fv-row py-2 w-100 fv-plugins-icon-container">
            <CustomFormLable row={row} />
            <Card rounded="8" style="white">
                <div className="d-flex align-items-center gap-4 p-2">
                    <FileInput
                        placeholder={row.placeholder ?? 'Choose File'}
                        multiple={false}
                        accept="image/png, image/gif, image/jpeg, application/pdf"
                        value={row.selectedFile == null ? null : [row.selectedFile]}
                        onChange={(files) => row.onInput?.({ target: { files } }, getValues)}
                    />
                    {row.uploaded === true ? <Icon name="check_circle" className="text-muted icon-adaptive" /> : null}
                    {row.uploadedBase64 != null
                        ? <Icon name="download_for_offline_24dp" className="text-muted icon-adaptive" onClick={() => window.open(row.uploadedBase64)} />
                        : null}
                </div>
            </Card>
            {_.get(errors, row.id) != null && <div className="text-danger">{_.get(errors, row.id).message}</div>}
        </div>
    }

    return <div className="fv-row  py-2 w-100 fv-plugins-icon-container">

        <CustomFormLable row={row} />
        <div className={'d-flex align-items-center gap-4'}>
            <input
                {...register(row.id, row.required === true ? { required: `Field "${String(row.content?.[0])}" is required` } : {})}
                className="form-control form-control-solid form-control-lg"
                name={row.id}
                onInputCapture={row.onInput != null
                    ? (e: FormEvent<HTMLInputElement>) => {
                        row.onInput(e, getValues)
                    }
                    : () => { }}
                accept={`image/png, image/gif, image/jpeg${row.id === 'avatar' ? '' : ', application/pdf'}`}
                type={"file"}
                placeholder={row.placeholder ?? 'Choose File'}
                multiple={row.multiple != null}
            />
            {
                row.uploaded === true
                    ? <Icon name={'check_circle'} className={'text-muted icon-adaptive'} />
                    : <></>
            }
            {
                row.uploadedBase64 != null
                    ? <Icon name={'download_for_offline_24dp'} className={'text-muted icon-adaptive'} onClick={() => {
                        window.open(row.uploadedBase64)
                    }} />
                    : <></>
            }
        </div>
        {_.get(errors, row.id) != null && (
            <div className="text-danger">{_.get(errors, row.id).message}</div>
        )}

    </div>
}
